// import React, { useRef, useEffect, useState } from "react";
// import { useParams } from "react-router-dom";

// const AutoScrollComponent = ({ userId, props }) => {
//   const containerRef = useRef(null);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [autoScroll, setAutoScroll] = useState(false);
//   const [sessionData, setSessionData] = useState([]);
//   const [relevant, setRelevant] = useState(null);
//   const [irrelevant, setIrrelevant] = useState(null);
//   const { session_id } = useParams();

//   useEffect(() => {
//     if (
//       autoScroll &&
//       containerRef.current &&
//       currentIndex < sessionData.length
//     ) {
//       const scrollInterval = setInterval(() => {
//         containerRef.current.scrollTop +=
//           currentIndex === sessionData.length - 1
//             ? containerRef.current.scrollHeight - containerRef.current.scrollTop
//             : 1;
//       }, 50);

//       const nextParagraphTimeout = setTimeout(() => {
//         setCurrentIndex((prevIndex) => prevIndex + 1);
//       }, 2000);

//       return () => {
//         clearInterval(scrollInterval);
//         clearTimeout(nextParagraphTimeout);
//       };
//     }
//   }, [autoScroll, currentIndex, sessionData]);

//   const toggleAutoScroll = () => {
//     setAutoScroll(!autoScroll);
//   };

//   useEffect(() => {
//     // const intervalId = setInterval(sendSessionId, 180000);
//     const intervalId = setInterval(sendSessionId, 60000);
//     return () => clearInterval(intervalId);
//   }, [session_id]);
//   const sendSessionId = async () => {
//     try {
//       const data = {
//         session_id: session_id,
//         user_id: userId,
//       };
//       const response = await props.admin.questionData(data);
//       if (response.success === true) {
//         const receivedData = response.data;
//         setSessionData((prevData) => [...prevData, ...receivedData]);
//       } else {
//         setSessionData("");
//       }
//       // const jsonStr = JSON.stringify(data);
//       // const sendWebsocket = new WebSocket("ws://0.tcp.in.ngrok.io:17391/transcript/ws_questions ");
//       // console.log("sendWebsocket data:", sendWebsocket);
//       // sendWebsocket.onopen = () => {
//       // sendWebsocket.send(jsonStr);
//       // };
//       // sendWebsocket.onmessage = (event) => {
//       // const receivedData = JSON.parse(event.data);
//       // console.log("Received data:", receivedData);
//       // setSessionData((prevData) => [...prevData, ...receivedData]);
//       // };
//       // sendWebsocket.onerror = (error) => {
//       // console.error("WebSocket Error:", error);
//       // };
//       // sendWebsocket.onclose = () => {
//       // console.log("WebSocket connection closed");
//       // };
//     } catch (error) {
//       console.error("Error occurred while sending data:", error);
//     }
//   };

//   const handleMarkedQuestion = async (question, state) => {
//     try {
//       const data = {
//         question_text: question,
//         is_relevant: state,
//       };
//       const response = await props.admin.updatesRelevant(data);
//       if (response.success === true) {
//         console.log("handleMarkedQuestion", response);
//         // const receivedData = response.data;
//         // setSessionData((prevData) => [...prevData, ...receivedData]);
//       } else {
//         // setSessionData("");
//       }
//     } catch (error) {
//       console.error("Error occurred while sending data:", error);
//     }
//   };
//   return (
//     <div>
//       <div
//         ref={containerRef}
//         // style={{ overflowY: "scroll", height: "51vh", marginBottom: 10 }}
//         className="speaker-transcrption"
//       >
//         {sessionData.map((paragraph, index) => (
//           <div
//             key={index}
//             style={{
//               flex: "1",
//               padding: "10px",
//               display: "flex",
//               justifyContent: "space-between",
//             }}
//           >
//             <p>{paragraph}</p>
//             <div className="relevantbutton">
//               <button
//                 className="relevantactive"
//                 onClick={() => {handleMarkedQuestion(paragraph,true);
//                   setRelevant(true);
//                   setIrrelevant(false);
//                 }}
//                 disabled={relevant}
//               >
//                 Relevant
//               </button>
//               &nbsp; &nbsp;
//               <button
//                 onClick={() => {handleMarkedQuestion(paragraph,false);
//                   setRelevant(false);
//                   setIrrelevant(true);
//                 }}
//                 disabled={irrelevant}
//               >
//                 Irrelevant
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>
//       <div className="questscrolling">
//         <button className="btn btn-primary btn-sm" onClick={toggleAutoScroll}>
//           {autoScroll ? "Stop Auto Scroll" : "Start Auto Scroll"}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default AutoScrollComponent;

import React, { useRef, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const AutoScrollComponent = ({ userId, props }) => {
  const containerRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [autoScroll, setAutoScroll] = useState(false);
  const [sessionData, setSessionData] = useState([]);
  const [disabledButtons, setDisabledButtons] = useState({});

  const { session_id } = useParams();

  // useEffect(() => {
    // if (autoScroll && containerRef.current && currentIndex < sessionData.length) {
      // const scrollInterval = setInterval(() => {
        // containerRef.current.scrollTop += 1;
      // }, 50);

      // const nextParagraphTimeout = setTimeout(() => {
        // setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, sessionData.length - 1));
      // }, 2000);

      // return () => {
        // clearInterval(scrollInterval);
        // clearTimeout(nextParagraphTimeout);
      // };
    // }
  // }, [autoScroll, currentIndex, sessionData]);

  const toggleAutoScroll = () => {
    setAutoScroll((prev) => !prev);
  };

  // useEffect(() => {
    // const intervalId = setInterval(sendSessionId, 120000);
    // return () => clearInterval(intervalId);
  // }, [session_id]);
// 
  const sendSessionId = async () => {
    try {
      const data = {
        session_id,
        user_id: userId,
      };
      const response = await props.admin.questionData(data);
      if (response.success) {
        const receivedData = response.data || [];
        setSessionData((prevData) => [...prevData, ...receivedData]);
      } else {
        console.error("Failed to fetch session data");
      }
    } catch (error) {
      console.error("Error occurred while sending data:", error);
    }
  };

  const handleMarkedQuestion = async (question, isRelevant) => {
    try {
      const data = {
        question_text: question,
        is_relevant: isRelevant,
      };
      const response = await props.admin.updatesRelevant(data);
      if (response.success) {
        setDisabledButtons((prev) => ({
          ...prev,
          [question]: isRelevant,
        }));
      } else {
        console.error("Failed to update question relevance");
      }
    } catch (error) {
      console.error("Error occurred while updating question relevance:", error);
    }
  };

  // useEffect(()=>{
    // const getQuestion = async () => {
      // try {
        // const data = {
          // session_id: session_id, 
        // };
        // const response = await props.admin.getQuestionList(data);
        // if (response.success) {
          // const receivedData = response.questions || [];
          // setSessionData((prevData) => [...prevData, ...receivedData]);
        // } else {
          // console.error("Failed to fetch session data");
        // }
      // } catch (error) {
        // console.error("Error occurred while sending data:", error);
      // }
    // };
    // getQuestion();
  // },[])



  return (
    <>
      <div
        ref={containerRef}
        className="speaker-transcrption"
        // style={{ overflowY: "auto", height: "60vh", marginBottom: "10px" }}
      >
        {sessionData.map((paragraph, index) => (
          <div
            key={index}
            style={{
              flex: "1",
              padding: "10px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p>{paragraph}</p>
            <div className="relevantbutton">
              <button
                className="relevantactive"
                onClick={() => handleMarkedQuestion(paragraph, true)}
                disabled={disabledButtons[paragraph] === true}
              >
                Relevant
              </button>
              &nbsp; &nbsp;
              <button
                onClick={() => handleMarkedQuestion(paragraph, false)}
                disabled={disabledButtons[paragraph] === false}
              >
                Irrelevant
              </button>
            </div>
          </div>
        ))}
      </div>
      {/*<div className="questscrolling">
        <button className="btn btn-primary btn-sm" onClick={toggleAutoScroll}>
          {autoScroll ? "Stop Auto Scroll" : "Start Auto Scroll"}
   </button>
      </div>*/}
      </>
    
  );
};

export default AutoScrollComponent;

